module.exports = __webpack_public_path__ + "static/media/patent_vt.f4e1a87e.21b033f3.jpg";